/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-target',
  templateUrl: './widget-layers-target.component.html',
  styleUrls: ['./widget-layers-target.component.css']
})
export class WidgetLayersTargetComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(value: number) {
    this.widgetLayers.layer(this.current).change({ gaugeTarget: value });
    if(this.widgetLayers.uid.value === this.current) this.widgetLayers.duplicateLayersOptions({ gaugeTarget: value }, this.current);
  }

}
